var chipLabel = 'fx_b722dd09_in7h9q1';
var chipLabelHorizontalGap = 'var(--fx_b722dd09_in7h9q0)';

export { chipLabel, chipLabelHorizontalGap };
//# sourceMappingURL=label.vanilla.mjs.map
